module.exports = __webpack_public_path__ + "img/aeroland-app-showcase-image-04.e78e8662.png";